// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationTH from './locales/th.json';
import translationEN from './locales/en.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      th: { translation: translationTH },
      en: { translation: translationEN }
    },
    fallbackLng: 'th',
    interpolation: { escapeValue: false },
    detection: { order: ['localStorage', 'cookie'], caches: ['localStorage'] }
  });

export default i18n;
